import {jwtServerInstance} from "../index";
import qs from	'qs'

export const querySaleman = (queryform,pagination)=>{
    return jwtServerInstance.request({
        url:'/b2csaleman/querysaleman',
        method:'post',
        data:qs.stringify({
            saleman: queryform.saleman,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const queryBusiness = (queryform,pagination)=>{
    return jwtServerInstance.request({
        url:'/b2csaleman/querybusiness',
        method:'post',
        data:qs.stringify({
            businessName: queryform.businessName,
            salemanName: queryform.salemanName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const addSalemanWebSetting = (webSettingData)=>{
    return jwtServerInstance.request({
        url: '/b2csaleman/addsalemanwebsetting',
        method: 'post',
        data: webSettingData
    });
}

export const querySalemanWebSetting = ()=>{
    return jwtServerInstance.request({
        url: '/b2csaleman/querysalemanwebsetting',
        method: 'post'
    });
}

export const queryBusinessContactInfo = ()=>{
    return jwtServerInstance.request({
        url: '/b2csaleman/querybusinesscontact',
        method: 'post'
    });
}

export const queryCustomer = (queryform,pagination)=>{
    return jwtServerInstance.request({
        url:'/b2csaleman/querycustomer',
        method:'post',
        data:qs.stringify({
            customerName: queryform.customerName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const addSaleman = (queryform)=>{
    return jwtServerInstance.request({
        url:'/b2cmanagepersons/addsaleman',
        method:'post',
        data:qs.stringify({
            salemanName: queryform.salemanName,
            businessRecommendRate: queryform.businessRecommendRate
        })
    })
}

//参数配置列表查询接口
export const addSalemanRemarks = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cmanagepersons/addremarks',
        method:'post',
        data:qs.stringify({
            id:queryForm.salemanId,
            remarks:queryForm.remarks
        })
    })
}

export const querySalemanBusinessDataTotalReport = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querybusinesstotalreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            salemanName: queryForm.userName,
            businessUserName: queryForm.businessUserName,
            businesstype: queryForm.businesstype,
        })
    })
}

export const querySalemanBusinessDataReport = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querybusinessreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            userId:queryForm.userId,
            salemanName: queryForm.userName,
            businessUserName: queryForm.businessUserName,
            businesstype:queryForm.businesstype,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const querySalemanSelfDataTotalReport = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querysalemanbusinesstotalreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            salemanName: queryForm.salemanName,
            upBusinessName: queryForm.upBusinessName,
            businesstype: queryForm.businesstype
        })
    })
}

export const querySalemanselfDataReport = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querysalemanreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            salemanName: queryForm.salemanName,
            upBusinessName: queryForm.upBusinessName,
            businesstype: queryForm.businesstype,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


export const querySalemanProfit = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/queryprofit',
        method:'post',
        data:qs.stringify({
            userName:queryForm.userName,
            moneyStatus:queryForm.moneyStatus,
            returnType:queryForm.returnType,
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


export const querySalemanOrderNum = () => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querysalemanordernum',
        method:'post'
    })
}


//新增商家利润获取
export const queryBusinessProfit = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querybprofit',
        method:'post',
        data:qs.stringify({
            userName:queryForm.userName,
            moneyStatus:queryForm.moneyStatus,
            returnType:queryForm.returnType,
            startTime:queryForm.startTime,
            endTime:queryForm.endTime,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


export const queryBusinessOrderNum = () => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querybordernum',
        method:'post'
    })
}


export const querySalemanPriceModeData = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querypricemode',
        method:'post',
        data:qs.stringify({
            userName:queryForm.saleman,
            priceModeType:queryForm.priceModeType,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}



export const querySalemanPriceModes = (priceModeType) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querypricemodelist',
        method:'post',
        data:qs.stringify({
            priceModeType:priceModeType
        })
    })
}


export const querySalemanPriceSetData = (userName, b2cTaskTypeId, priceModeType) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querypricedatalist',
        method:'post',
        data:qs.stringify({
            userName: userName,
            b2cTaskTypeId:b2cTaskTypeId,
            priceModeType: priceModeType
        })
    })
}

export const addSalemanPriceSetData = (b2cSalemanWebPriceSettings, userName, priceModeType) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/addpricesetting',
        method:'post',
        data:{
            b2cSalemanWebPriceSettings,
            userName,
            priceModeType
        }
    })
}



export const querySalemanPriceSetTemplateData = (modelId, b2cTaskTypeId) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querytemplateprice',
        method:'post',
        data:qs.stringify({
            modelId:modelId,
            b2cTaskTypeId: b2cTaskTypeId
        })
    })
}


export const updateSalemanPriceSetData = (b2cSalemanWebPriceSettings, modelId) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/updatewebprice',
        method:'post',
        data:{b2cSalemanWebPriceSettings,modelId}
    })
}


export const saveSalemanPriceSetTemplate= (b2cSalemanWebMoneySettings, userName, priceModeType, b2cTaskTypeId) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/savepricetemplate',
        method:'post',
        data:{
            b2cSalemanWebMoneySettings,
            userName,
            priceModeType,
            b2cTaskTypeId
        }
    })
}


export const querySalemanPriceSetModelTemplateData = (modelId, b2cTaskTypeId) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/querymtemplateprice',
        method:'post',
        data:qs.stringify({
            modelId:modelId,
            b2cTaskTypeId: b2cTaskTypeId
        })
    })
}

export const updateModeNameWithModelId = (modelId, modeName) => {
    return jwtServerInstance.request({
        url:'/b2csaleman/updatemodenamewithid',
        method:'post',
        data:qs.stringify({
            modelId:modelId,
            modeName: modeName
        })
    })
}

export const saveSalemanMoneySetData = (b2cSalemanWebMoneySettings, userName, priceModeType) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/savesalemanmoneytemplate',
        method:'post',
        data:{
            b2cSalemanWebMoneySettings,
            userName,
            priceModeType
        }
    })
}

export const querySalemanMoneySetModelTemplateData = (modelId, b2cTaskTypeId) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/querytemplateprice',
        method:'post',
        data:qs.stringify({
            modelId:modelId,
            b2cTaskTypeId: b2cTaskTypeId
        })
    })
}

export const addSalemanMoneySetBatchData = (b2cSalemanWebMoneySettings, b2cTaskTypeId, salemanId) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/addsalemanmoneybatch',
        method:'post',
        data:{
            b2cSalemanWebMoneySettings,
            b2cTaskTypeId,
            salemanId
        }
    })
}


export const delSalemanMoneySetBatchData = (b2cSalemanWebMoneySettings) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/deleteslamenmoneys',
        method:'post',
        data: b2cSalemanWebMoneySettings
    })
}
